export const attachmentPolicyHyperLinkText = "YsE6wb";
export const attachmentPolicyInformationReadOnly = "PyUube";
export default {attachmentPolicyHyperLinkText,attachmentPolicyInformationReadOnly};